import { Search, X } from "lucide-react";

import { cn } from "@/lib/utils";

interface SidebarSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const SidebarSearch = ({ value, onChange }: SidebarSearchProps) => {
  return (
    <div className="border-b border-sidebar-border/40 px-3 pb-3 pt-3">
      <div
        className={cn(
          "group flex h-9 items-center gap-2 rounded-lg px-2.5",
          "border border-sidebar-border bg-sidebar-accent/40",
          "transition-colors focus-within:border-sidebar-ring focus-within:bg-sidebar-accent/60",
        )}
      >
        <Search className="h-4 w-4 shrink-0 text-sidebar-foreground/40 transition-colors group-focus-within:text-sidebar-foreground/70" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Buscar menu..."
          aria-label="Buscar menu"
          className={cn(
            "w-full border-0 bg-transparent p-0 text-sm outline-none",
            "text-sidebar-foreground placeholder:text-sidebar-foreground/40",
          )}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label="Limpar busca"
            className="shrink-0 rounded text-sidebar-foreground/40 outline-none transition-colors hover:text-sidebar-foreground focus-visible:ring-2 focus-visible:ring-sidebar-ring"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};
